export function PlusBadge() {
  return (
    <svg
      width="48"
      height="22"
      viewBox="0 0 48 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_2226_2402)">
        <rect
          width="48"
          height="22"
          rx="8"
          fill="url(#paint0_linear_2226_2402)"
        />
        <rect
          x="0.75"
          y="0.75"
          width="46.5"
          height="20.5"
          rx="7.25"
          stroke="white"
          stroke-width="1.5"
        />
        <path
          d="M10.6399 14.892H8.71988V7.296H12.1039C12.8639 7.296 13.4719 7.388 13.9279 7.572C14.3839 7.756 14.7119 8.056 14.9119 8.472C15.1119 8.888 15.2119 9.452 15.2119 10.164C15.2119 10.836 15.1119 11.384 14.9119 11.808C14.7119 12.224 14.3839 12.532 13.9279 12.732C13.4719 12.932 12.8639 13.032 12.1039 13.032H10.6399V14.892ZM11.7919 8.868H10.6399V11.46H11.7919C12.3599 11.46 12.7399 11.364 12.9319 11.172C13.1239 10.98 13.2199 10.644 13.2199 10.164C13.2199 9.708 13.1239 9.38 12.9319 9.18C12.7399 8.972 12.3599 8.868 11.7919 8.868ZM22.4716 13.26V14.892H16.9516V7.296H18.8716V13.26H22.4716ZM30.6109 7.296V11.772C30.6109 12.556 30.5149 13.184 30.3229 13.656C30.1389 14.128 29.8149 14.472 29.3509 14.688C28.8869 14.896 28.2309 15 27.3829 15C26.5029 15 25.8189 14.896 25.3309 14.688C24.8509 14.472 24.5149 14.128 24.3229 13.656C24.1309 13.184 24.0349 12.556 24.0349 11.772V7.296H25.9549V11.736C25.9549 12.144 25.9949 12.464 26.0749 12.696C26.1549 12.928 26.2989 13.092 26.5069 13.188C26.7149 13.276 27.0069 13.32 27.3829 13.32C27.7349 13.32 28.0029 13.276 28.1869 13.188C28.3789 13.092 28.5109 12.928 28.5829 12.696C28.6549 12.464 28.6909 12.144 28.6909 11.736V7.296H30.6109ZM32.5785 12.936C32.9305 13.056 33.3145 13.152 33.7305 13.224C34.1545 13.288 34.5745 13.32 34.9905 13.32C35.5585 13.32 35.9785 13.296 36.2505 13.248C36.5305 13.192 36.7145 13.108 36.8025 12.996C36.8905 12.884 36.9345 12.74 36.9345 12.564C36.9345 12.412 36.9025 12.292 36.8385 12.204C36.7745 12.116 36.6505 12.048 36.4665 12C36.2825 11.944 36.0105 11.9 35.6505 11.868L34.8585 11.796C34.2665 11.74 33.7985 11.616 33.4545 11.424C33.1185 11.232 32.8785 10.976 32.7345 10.656C32.5985 10.328 32.5305 9.936 32.5305 9.48C32.5305 8.936 32.6385 8.496 32.8545 8.16C33.0785 7.824 33.4385 7.58 33.9345 7.428C34.4305 7.268 35.0905 7.188 35.9145 7.188C36.9865 7.188 37.8705 7.328 38.5665 7.608L38.5305 9.24L38.4945 9.288C37.7025 9.008 36.8745 8.868 36.0105 8.868C35.5945 8.868 35.2745 8.892 35.0505 8.94C34.8265 8.98 34.6705 9.048 34.5825 9.144C34.4945 9.24 34.4505 9.376 34.4505 9.552C34.4505 9.728 34.4785 9.86 34.5345 9.948C34.5985 10.036 34.7225 10.104 34.9065 10.152C35.0905 10.192 35.3585 10.232 35.7105 10.272L36.4665 10.356C37.1065 10.428 37.5985 10.556 37.9425 10.74C38.2865 10.924 38.5225 11.172 38.6505 11.484C38.7865 11.788 38.8545 12.16 38.8545 12.6C38.8545 13.136 38.7385 13.584 38.5065 13.944C38.2825 14.296 37.9145 14.56 37.4025 14.736C36.8905 14.912 36.2065 15 35.3505 15C34.7905 15 34.2865 14.972 33.8385 14.916C33.3905 14.852 32.9545 14.768 32.5305 14.664V12.972L32.5785 12.936Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_2226_2402"
          x="0"
          y="-3"
          width="48"
          height="25"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3.85" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.0473821 0 0 0 0.41 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2226_2402"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2226_2402"
          x1="6.72"
          y1="-2"
          x2="37.5885"
          y2="25.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#62F062" stop-opacity="0.89" />
          <stop offset="1" stop-color="#01B1E1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
